import { Component } from '@angular/core';
import { EditRejectionReason } from '../../../../components/admin-dashboard-component/rejection-reasons/edit-rejection-reason/edit-rejection-reason';
@Component({
  selector: 'app-edit-reason',
  imports: [EditRejectionReason],
  templateUrl: './edit-reason.html',
  styleUrl: './edit-reason.scss',
})
export class EditReason {}
